import crud, { ApiResponse } from "../crud";

export interface TempAgreement {
  id: number;
  business_profile_id: number;
  office_id: number;
  code: string;
  renter_name: string;
  address: string;
  ogrn: number;
  inn: number;
  kpp: number;
  bik: string;
  bank_account: string;
  bank_name: string;
  correspondent_account: string;
  phone_number: string;
  email: string;
  scan: string;
  active: boolean;
  price: number;
  start_date: string;
  end_date: string;
  number: string;
  requisite: number;
  business_profile_name: string;
  main_photo: string;
  office_name: string;

  renter_id?: number;
  requisite_id?: number;
}

export function TempAgreementsAPI(baseUrl: string) {
  return {
    get: async (code: string) => {
      return (await crud.get(
        `${baseUrl}/temp-agreements/${code}`,
        undefined,
        false,
      )) as ApiResponse<TempAgreement>;
    },
    submit: async (code: string, data: Partial<TempAgreement>) => {
      return (await crud.post(
        `${baseUrl}/temp-agreements/${code}`,
        data,
        true,
      )) as ApiResponse<TempAgreement>;
    },
  };
}
